const initialState = {
  estimates: [],
  loading: false,
  error: null
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_ESTIMATES': {
      return { ...state, loading: true }
    }
    case 'GET_ESTIMATES_SUCCESS': {
      return {
        ...state,
        loading: false,
        error: null,
        estimates: action.payload.data
      }
    }
    case 'USER_LOGOUT': {
      return { ...initialState }
    }
    default:
      return state
  }
}

export default reducer
